import { I18n } from '@calendly/i18n'
import { IconMailShare } from '@calendly/ui/components/glyphs/IconMailShare'
import { IconMessages } from '@calendly/ui/components/glyphs/IconMessages'
import { IconWindmill } from '@calendly/ui/components/glyphs/IconWindmill'

import { triggerTitleText } from 'features/workflows'
import { getVisibleActions, isSmsAction } from 'services/workflows/actions'

const getActionType = (action) => (
  action.configuration?.type || action.configuration_type
)

const isEmailAction = (actionType) => actionType?.startsWith('booking.email')

const getVisibleActionTypes = (workflow) => (
  getVisibleActions(workflow.workflow_rule?.workflow_actions ?? [])
    .map(getActionType)
    .filter(Boolean)
)

// Icons follow Figma Event-type-editor v4 Automations cards (node 2780:386175):
// email → mail-share, text → messages, multiple actions → windmill.
export const getCrudAutomationIcon = (workflow) => {
  const actionTypes = getVisibleActionTypes(workflow)

  if (actionTypes.length === 1) {
    if (isEmailAction(actionTypes[0])) return IconMailShare
    if (isSmsAction(actionTypes[0])) return IconMessages
  }

  return IconWindmill
}

export const getCrudAutomationSubtitle = (workflow, isRebrandEnabled = false) => {
  const actionTypes = getVisibleActionTypes(workflow)
  const timing = triggerTitleText(workflow.type, workflow.workflow_rule, isRebrandEnabled)

  if (actionTypes.length === 1 && isEmailAction(actionTypes[0])) {
    return I18n.t(
      'publisher.event_type_editor.sections.more_options.notifications.card_copy.automation_email_sent',
      { timing }
    )
  }

  if (actionTypes.length === 1 && isSmsAction(actionTypes[0])) {
    return I18n.t(
      'publisher.event_type_editor.sections.more_options.notifications.card_copy.automation_text_sent',
      { timing }
    )
  }

  return I18n.t(
    'publisher.event_type_editor.sections.more_options.notifications.card_copy.automation_multiple_actions',
    { timing }
  )
}
